import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { instanceOf } from "prop-types";
import compose from "ramda/src/compose";
import { Button, ContextMenu, Link } from "shared/components";
import iconMenu from "assets/svg/sanduiche.svg";
import IconUser from "assets/svg/usuario.svg";
import iconMenuWhite from "assets/svg/menu-icon-white.svg";
import styles from "../styles.css";
import { saveOperation } from "services/state/actions";

class Menu extends Component {
  state = {
    isOpen: false,
  };

  toggle() {
    this.setState({ isOpen: false });
  }

  onClick = (type, obs) => {
    if (type !== "") {
      const { customer } = this.props;

      this.props.saveOperation(customer, "", type, "VIEW", "SUCCESS", "", obs);
    }

    this.setState({ isOpen: !this.state.isOpen });
  };

  onOuterAction = () => {
    this.toggle();
  };

  render() {
    const { customer, products } = this.props;
    const { isMpe } = products;

    const trigger = (
      <Button onClick={() => this.onClick("")}>
        <img src={iconMenu} alt="" className={styles.iconMenu} /> Menu
      </Button>
    );

    if (!this.props.container) return null;

    return (
      <ContextMenu
        isOpen={this.state.isOpen}
        onOuterAction={this.onOuterAction}
        container={this.props.container}
        place="start"
        tipSize={0.01}
        trigger={trigger}
        menu
      >
        <div>
          <img src={iconMenuWhite} alt="" className={styles.iconMenuWhite} />
          Menu
        </div>

        <Link
          to="/fixed-voice"
          onClick={() => this.onClick("DEMAND_MONITORING", "Voz Fixa")}
        >
          Voz Fixa
        </Link>
        <Link
          to="/incident-manager"
          onClick={() =>
            this.onClick("DEMAND_MONITORING", "Histórico de Solicitações")
          }
        >
          Solicitações
        </Link>

        {!isMpe && (
          <Link
            to="/tickets"
            onClick={() =>
              this.onClick("DETAILING", "Detalhamento de Chamados")
            }
          >
            Suporte Técnico
          </Link>
        )}
        <Link
          to="/detailing-pos-pre-controle"
          onClick={() => this.onClick("DETAILING", "Detalhamento de Conta")}
        >
          Detalhamento de chamadas
        </Link>

        <Link
          to="/traffic-pre-controle"
          onClick={() => this.onClick("DETAILING", "Tráfego pré pago")}
        >
          Terminação de Tráfego Pré-pago
        </Link>

        <Link
          to="/data-traffic"
          onClick={() => this.onClick("DATA_TRAFFIC", "Tráfego de Dados")}
        >
          Tráfego de dados
        </Link>

        <Link
          to="/negotiation"
          onClick={() => this.onClick("NEGOTIATION", "Negociação de Conta")}
        >
          Negociar Faturas
        </Link>

        <Link to="/invoices" onClick={() => this.onClick("INVOICE", "Fatura")}>
          Ver minhas faturas
        </Link>

        <div className={styles.separate} />

        <div className={styles.user}>
          <img src={IconUser} alt="" />

          {customer && customer.name ? (
            <p>{customer.name.toLowerCase()}</p>
          ) : null}
        </div>

        <Link
          isExternal
          to="https://portal-algartelecom-files.s3.sa-east-1.amazonaws.com/documents/document_files/000/000/970/original/Manual_portal_do_cliente_b2b.pdf"
          onClick={() => this.onClick("MANUAL", "Manual do Usuário")}
          target="_blank"
        >
          Manual do Usuário
        </Link>

        {customer ? (
          <Link
            to="/customer"
            onClick={() => this.onClick("REGISTER", "Dados Cadastrais")}
          >
            Cadastro
          </Link>
        ) : null}
      </ContextMenu>
    );
  }
}

Menu.propTypes = {
  container: instanceOf(Element),
};

const mapStateToProps = ({ bills, customer, products }) => ({
  bills,
  customer: customer.data,
  products,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, { saveOperation })
);

export default enhance(Menu);



// WEBPACK FOOTER //
// ./src/components/Masthead/components/Menu.js